import { Text } from "@mantine/core";
import { modals } from "@mantine/modals";

import { t } from "@/config/i18n";

export type AlertType = "info" | "success" | "warning" | "danger";

interface ConfirmOptions {
	title: string;
	message: string;
	type?: AlertType;
	confirmLabel?: string;
	cancelLabel?: string;
}

const TYPE_COLOR: Record<AlertType, string> = {
	info: "hooky",
	success: "success",
	warning: "warning",
	danger: "danger",
};

// Promise-based confirm dialog.
export function confirm({
	title,
	message,
	type = "info",
	confirmLabel,
	cancelLabel,
}: ConfirmOptions): Promise<boolean> {
	return new Promise((resolve) => {
		modals.openConfirmModal({
			title,
			children: <Text size="sm">{message}</Text>,
			labels: {
				confirm: confirmLabel ?? t("confirm").capfirst(),
				cancel: cancelLabel ?? t("cancel").capfirst(),
			},
			confirmProps: { color: TYPE_COLOR[type] },
			closeOnClickOutside: false,
			onConfirm: () => resolve(true),
			onCancel: () => resolve(false),
			onClose: () => resolve(false),
		});
	});
}
